/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

/**
 * FIX OrdStatus (tag 39).
 */
export type PlaeeOrderResponseDtoOrdStatus =
  (typeof PlaeeOrderResponseDtoOrdStatus)[keyof typeof PlaeeOrderResponseDtoOrdStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlaeeOrderResponseDtoOrdStatus = {
  NUMBER_0: '0',
  NUMBER_1: '1',
  NUMBER_2: '2',
  NUMBER_4: '4',
  NUMBER_6: '6',
  NUMBER_8: '8',
  A: 'A',
  C: 'C',
  E: 'E',
} as const;
